import React from "react";
import { Box, IconButton, Paper, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styles } from "./TutorialContent.styles";

const TopMenuOverlay = ({ onClose, child }) => {
  const theme = useTheme();

  const handleBackdropClick = (e) => {
    // Only close if clicking the backdrop, not the paper
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <Box
      sx={{ ...styles.overlay, zIndex: theme.zIndex.drawer + 1 }}
      onClick={handleBackdropClick}
    >
      <Paper sx={styles.overlayPaper}>
        <IconButton onClick={onClose} sx={styles.closeButton}>
          <CloseIcon />
        </IconButton>
        {child}
      </Paper>
    </Box>
  );
};

export default TopMenuOverlay;
